// Hide/Show an image

export type PropertyMediaLocation = 'main' | 'plan' | 'none';

const apiBaseUrl = import.meta.env.VITE_API_BASE_URL;

export const setPropertyMediaLocation = async (
  propertyId: number,
  imageUrl: string,
  location: PropertyMediaLocation,
  token: string,
): Promise<Response> => {
  const mediaId = imageUrl.split('/').slice(-1)[0];
  const response = await fetch(
    `${apiBaseUrl}/properties/${propertyId}/media/${mediaId}/location`,
    {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      },
      method: 'PUT',
      body: JSON.stringify({
        location: location,
      }),
    },
  );

  if (!response.ok) {
    throw new Error(
      `Failed to set property media visibility: ${response.statusText}`,
    );
  }

  return response;
};
